

define(['squid/index'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xomodel.shippingMethod', ['squid']).factory('$ShippingMethodModel', function ($Model, $Api) {
        return $Model.extend('ShippingMethodModel', {
            api: new $Api({
                uri: '/api/shippingtax/charges'
            }),

            getShippingMethodId: function getShippingMethodId(shippingMethodType) {
                var shippingMethodsMap = {
                    DEFAULT: '0',
                    AIR_SERVICE: '1',
                    ECONOMY: '2',
                    EXPEDITED_AIR_SERVICE: '3',
                    EXPEDITED_FLAT_RATE_SHIPPING: '4',
                    EXPRESS: '5',
                    EXPRESS_DOMESTIC: '6',
                    FREE_SHIPPING: '7',
                    GROUND: '8',
                    GLOBAL_PRIORITY: '9',
                    INTERNATIONAL_ECONOMY: '10',
                    INTERNATIONAL_EXPEDITED: '11',
                    INTERNATIONAL_EXPRESS: '12',
                    INTERNATIONAL_EXPRESS_AIR: '13',
                    INTERNATIONAL_PRIORITY_AIR: '14',
                    NEXT_DAY: '15',
                    NEXT_DAY_AIR: '16',
                    NEXT_DAY_AIR_ECONOMY: '17',
                    ONE_DAY_SHIPPING: '18',
                    OVERNIGHT: '19',
                    OVERNIGHT_FLAT_RATE_SHIPPING: '20',
                    PICKUP: '21',
                    PRIORITY: '22',
                    RUSH_DELIVERY: '23',
                    STANDARD_DOMESTIC: '24',
                    STANDARD_EXPEDITED: '25',
                    STANDARD_FLAT_RATE_SHIPPING: '26',
                    STANDARD_INTERNATIONAL: '27',
                    STANDARD_SHIPPING: '28',
                    STORE_PICKUP: '29',
                    TWO_DAY_SHIPPING: '30',
                    WORLDWIDE_SHIPPING: '31',
                    TWO_DAY_AIR: '32'
                };

                return shippingMethodsMap[shippingMethodType];
            },

            isStorePickUp: function isStorePickUp(shipping_method_type) {
                return shipping_method_type === 'STORE_PICKUP' || shipping_method_type === 'PICKUP';
            }
        });
    }).factory('$ShippingRuleSummaryModel', function ($Model, $Api) {
        return $Model.extend('ShippingRuleSummaryModel', {
            api: new $Api({
                uri: '/api/shippingtax/:id/rulesSummary'
            })
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-models/src/shippingMethod/index.js
// module id = ./components/xo-models/src/shippingMethod/index.js
// module chunks = 1